export type AdService = {
  price: number;
  period: number;
  previousPrice: number | null;
};

export enum ServiceId {
  BUMPED = 'bump',
  VIPPED = 'vip',
  PREMIUM = 'featured',
  BUNDLE = 'bundle',
}
